import { Navigate, Outlet, useParams } from 'react-router-dom';
import { Routes } from '../../../../route/Routes';

export const UserDetail = () => {
  const { userId } = useParams();
  if (!userId) return <Navigate to={Routes.Study} />;
  return <Outlet />;
};
